import React from 'react';

import { CheckIcon, RemoveIcon } from '@gogame/components';

export default ({ value }) => {
  return value ? (
    <CheckIcon fontSize={'small'} />
  ) : (
    <RemoveIcon fontSize={'small'} />
  );
};
